import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import makeStyles from '@material-ui/styles/makeStyles'
import { ProductBuilderSummaryView } from './summary'
import { ProductBuilderState, UploadedFiles } from '../state'
import { connect } from 'react-redux'
import { ProductParametersRoot } from './params'
import { ProductBuilderNotificationsView } from './notifications'
import { ProductDescriptionView } from '../../product/views'
import LinearProgress from '@material-ui/core/LinearProgress'

const useStyles = makeStyles((theme: any) => ({
    root: {
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
        '& .parameters-card': {
            borderRadius: '0',
            [theme.breakpoints.up('md')]: {
                margin: theme.spacing(1, 2)
            }
        },
        '& .notification-card': {
            backgroundColor: '#f2f2f2',
            borderRadius: '0',
            [theme.breakpoints.up('md')]: {
                margin: theme.spacing(2, 2)
            }
        },
        '& .description-item': {
            [theme.breakpoints.down('sm')]: {
                order: 1
            }
        },
        '& .parameters-item': {
            [theme.breakpoints.down('sm')]: {
                order: 3
            },
            '& .loading-bar': {
                margin: '24px auto 0',
                width: '95%'
            }
        },
        '& .summary-item': {
            [theme.breakpoints.down('sm')]: {
                order: 2
            }
        },
        '& .MuiInputBase-input': {
            // Override input styles from style.css
            backgroundColor: 'transparent',
            boxShadow: 'none',
            boxSizing: 'content-box',
            padding: '6px 0 7px',
            '&:focus': {
                backgroundColor: 'transparent'
            }
        },
        '& .back-defaults': {
            color: '#a9cc78',
            marginTop: '24px',
            cursor: 'pointer'
        }
    }
}), { name: 'ProductBuilderStepParams' })

const productBuilderStepParamsView = (props: ProductBuilderState) => {
    const classes = useStyles(props)
    const [backToDefaultSettings, setBackToDefaultSettings] = useState(false)

    const changeToDefaultProductConfig = () => {
        props.dispatch({ type: 'PRODUCT_BUILDER_DEFAULT_PRODUCT_SET', params: props.product.configurationDefault})
        props.dispatch({ type: 'PRODUCT_BUILDER_COST_SET', params: { productConfiguration: props.product.configurationDefault }})
        setBackToDefaultSettings(true)
    }

    const removeUploadedFiles = (files: UploadedFiles, config: object, key: string ) => {
        files.map( item =>
            props.dispatch({ type: 'PRODUCT_BUILDER_FILE_DELETE', params: { productConfiguration: config, productParameterKey: key, productParameterValueFile: item.id }})
        )
    }

    const resetSetBackToDefaultSettings = () => {
        setBackToDefaultSettings(false)
    }

    return <Box>
        <Box>
            <Button
                className='ct-goBack'
                variant='contained'
                color='primary'
                onClick={() => props.dispatch({ type: 'PRODUCT_BUILDER_STEP_INDEX_CHANGE', params: props.stepIndex - 1 })} >
                Go back
            </Button>
        </Box>
        <Grid container className={classes.root} direction='column'>
            <Grid item xs={12} md={4} className='description-item'>
                <ProductDescriptionView product={props.product} pictureVisible={true} />
            </Grid>
            <Grid item xs={12} md={5} className='parameters-item'>
                <Card className='parameters-card'>
                    <CardHeader title='Configure your product parameters' />
                    <CardContent>
                        <ProductParametersRoot
                            backToDefaultSettings={backToDefaultSettings}
                            resetSetBackToDefaultSettings={resetSetBackToDefaultSettings}
                            removeUploadedFiles={removeUploadedFiles} />
                        <Grid item container justify='flex-start'>
                            <div className='back-defaults' onClick={changeToDefaultProductConfig} >Back to defaults</div>
                        </Grid>
                    </CardContent>
                </Card>
                {props.loading && <LinearProgress className='loading-bar' />}
                <ProductBuilderNotificationsView backToDefaultSettings={backToDefaultSettings} resetSetBackToDefaultSettings={resetSetBackToDefaultSettings}/>
            </Grid>
            <Grid item xs={12} md={3} container alignItems='stretch' className='summary-item'>
                <ProductBuilderSummaryView backToDefaultSettings={backToDefaultSettings} resetSetBackToDefaultSettings={resetSetBackToDefaultSettings}/>
            </Grid>
        </Grid>
    </Box>
}

export const ProductBuilderStepParamsView =
    connect((state: any) => state.productBuilderState)(productBuilderStepParamsView)
